jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchstart", handle, { passive: false });
    } else {
      this.addEventListener("touchstart", handle, { passive: true });
    }
  },
};

jQuery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchmove", handle, { passive: false });
    } else {
      this.addEventListener("touchmove", handle, { passive: true });
    }
  },
};

/**** Main menu ****/

$(".dropdown-toggle").dropdown();

var mobileNavigationQuery = window.matchMedia("(max-width: 1199.98px)");
var focusableNavigationSelector =
  'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
var navigationWrapper = $(".navigation-wrapper");
var headerContainer = $(".header-container");
var menuToggle = $(".navbar-button .hamburger");
var lastFocusedNavigationElement = null;

function setNavigationFocusableState(isEnabled) {
  navigationWrapper.find("a, button").not(menuToggle).each(function () {
    var element = $(this);

    if (isEnabled) {
      var originalTabindex = element.attr("data-nav-tabindex");

      if (originalTabindex !== undefined) {
        if (originalTabindex === "") {
          element.removeAttr("tabindex");
        } else {
          element.attr("tabindex", originalTabindex);
        }

        element.removeAttr("data-nav-tabindex");
      } else {
        element.removeAttr("tabindex");
      }

      return;
    }

    if (element.attr("data-nav-tabindex") === undefined) {
      element.attr("data-nav-tabindex", element.attr("tabindex") || "");
    }

    element.attr("tabindex", "-1");
  });

  navigationWrapper.attr("aria-hidden", isEnabled ? "false" : "true");
}

function isMobileNavigation() {
  return mobileNavigationQuery.matches;
}

function getSubmenuWrapper(item) {
  return item.children(".submenu-wrapper");
}

function getSubmenuToggle(item) {
  return item.children(".show-more");
}

function isSubmenuOpen(item) {
  return item.hasClass("open");
}

function setSubmenuToggleState(item, isOpen) {
  var toggle = getSubmenuToggle(item);
  if (!toggle.length) {
    return;
  }

  toggle.attr("aria-expanded", isOpen ? "true" : "false");
  toggle.attr(
    "aria-label",
    (isOpen ? "Close submenu" : "Open submenu") + ": " + item.children("a").text().trim(),
  );
}

function openSubmenu(item) {
  var submenu = getSubmenuWrapper(item);
  if (!submenu.length) {
    return;
  }

  item.addClass("open");
  setSubmenuToggleState(item, true);

  if (isMobileNavigation()) {
    submenu.stop(true, true).slideDown();
  }
}

function closeSubmenu(item) {
  var submenu = getSubmenuWrapper(item);
  if (!submenu.length) {
    return;
  }

  item.removeClass("open");
  setSubmenuToggleState(item, false);

  if (isMobileNavigation()) {
    submenu.stop(true, true).slideUp();
  }
}

function toggleSubmenu(item) {
  if (isSubmenuOpen(item)) {
    closeSubmenu(item);
    return;
  }

  openSubmenu(item);
}

function getNavigationFocusables() {
  return menuToggle
    .add(navigationWrapper.find(focusableNavigationSelector))
    .filter(":visible");
}

function trapNavigationFocus(event) {
  if (!isMobileNavigation() || !navigationWrapper.hasClass("navi-open")) {
    return;
  }

  if (event.key !== "Tab") {
    return;
  }

  var focusableItems = getNavigationFocusables();
  if (!focusableItems.length) {
    return;
  }

  var firstItem = focusableItems.get(0);
  var lastItem = focusableItems.get(focusableItems.length - 1);

  if (event.shiftKey && document.activeElement === firstItem) {
    event.preventDefault();
    lastItem.focus();
    return;
  }

  if (!event.shiftKey && document.activeElement === lastItem) {
    event.preventDefault();
    firstItem.focus();
  }
}

function openNavigation() {
  lastFocusedNavigationElement = document.activeElement;

  menuToggle.addClass("is-active");
  menuToggle.attr("aria-expanded", "true");
  menuToggle.attr("aria-label", "Close navigation");
  headerContainer.addClass("navi-open");
  navigationWrapper.addClass("navi-open");
  $("body").addClass("navi-open");
  setNavigationFocusableState(true);

  menuToggle.trigger("focus");
}

function closeAllSubmenus() {
  $(".navi li.sublevels.open").each(function () {
    closeSubmenu($(this));
  });
}

function closeNavigation() {
  menuToggle.removeClass("is-active");
  menuToggle.attr("aria-expanded", "false");
  menuToggle.attr("aria-label", "Open navigation");
  headerContainer.removeClass("navi-open");
  navigationWrapper.removeClass("navi-open");
  $("body").removeClass("navi-open");
  setNavigationFocusableState(false);

  closeAllSubmenus();

  if (lastFocusedNavigationElement instanceof HTMLElement) {
    $(lastFocusedNavigationElement).trigger("focus");
    return;
  }

  menuToggle.trigger("focus");
}

function syncNavigationState() {
  $(".navi li.sublevels").each(function () {
    var item = $(this);
    var submenu = getSubmenuWrapper(item);

    setSubmenuToggleState(item, isSubmenuOpen(item));

    if (isMobileNavigation()) {
      if (isSubmenuOpen(item)) {
        submenu.show();
      } else {
        submenu.hide();
      }
      return;
    }

    submenu.attr("style", "");
  });

  if (isMobileNavigation()) {
    setNavigationFocusableState(navigationWrapper.hasClass("navi-open"));
    return;
  }

  setNavigationFocusableState(true);
}

syncNavigationState();

$(window).on("resize", function () {
  syncNavigationState();
});

menuToggle.on("click", function () {
  if (navigationWrapper.hasClass("navi-open")) {
    closeNavigation();
    return;
  }

  openNavigation();
});

$("body").on("click", ".show-more", function (event) {
  event.preventDefault();
  event.stopPropagation();

  toggleSubmenu($(this).closest("li.sublevels"));
});

$("body").on("focusout", ".navi li.level1.sublevels", function () {
  var item = this;

  if (isMobileNavigation()) {
    return;
  }

  window.setTimeout(function () {
    if (!item.contains(document.activeElement)) {
      closeSubmenu($(item));
    }
  }, 0);
});

$(document).on("keydown", function (event) {
  trapNavigationFocus(event);
});
/**** Main menu end ****/
